module.exports = "<div>\n  <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/categories.component.html
// module id = ../../../../../src/app/pages/cerba/pages/categories/categories.component.html
// module chunks = 0